import useSWR from "swr";

export const useFetchNotActiveLineAccountsCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: notActiveLineAccountsCount, error, isLoading } = useSWR<number>(`external_api/restaurants/${restaurantId}/line-accounts/not-active/counts/?startDate=${startDate}&endDate=${endDate}`)
  return { notActiveLineAccountsCount, isLoading, error };
};

